import(/* webpackMode: "eager" */ "/agent/_work/14/s/apps/fdc/src/app/shop/product-details/forbidden.tsx");
